import React from 'react';
import profile from '../images/profile.png';

function ScientificCommitteeComite({ members, renderExpandableText }) {
  if (!members || members.length === 0) return null;

  return (
    <div className="honorary-committee-list-comite scientific-list-comite" style={{ marginBottom: '6vw' }}>
      <h2>COMITE SCIENTIFIQUE DU CONGRES</h2>
      <div className="committee-grid-comite">
        {members.map((member) => (
          <div key={member.id} className="committee-member-comite" data-member-id={member.id}>
            <div className="member-photo-comite">
              {member.logo && (
                <div className="company-logo-comite" >
                  <img
                    src={member.logo}
                    alt="Logo"
                    style={{ width: '100%', height: '100%', objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }}
                    onError={e => e.target.style.display = "none"}
                  />
                </div>
              )}
              <img src={member.image || profile} alt={member.name} />
            </div>
            <div className="member-info-comite">
              <h4 style={{ margin: 0, textAlign: 'center' }}>{member.name}</h4>
              <p>{renderExpandableText(member.title, member.id + '-title')}</p>
              <p>{renderExpandableText(member.organization, member.id + '-org')}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ScientificCommitteeComite;
